import { parse } from 'querystring';
import { useCallback, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from 'src/AppContext';
import Button from 'src/components/Button';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { getParseQueryString } from 'src/services/util';

export default function PaymentFail(): JSX.Element {
  const { t } = useTranslation();
  const history = useCustomHistory();
  const location = useLocation();
  const { productId, error_msg, payMethod, afterPaymentEndpoint } = getParseQueryString(location.search);
  const dispatch = useAppDispatch();

  const onClickRetry = useCallback(
    (e) => {
      e.preventDefault();
      history.push('/payment', {
        productId: productId as string,
        ...(payMethod
          ? {
              payMethod: payMethod as string,
            }
          : {}),
      });
    },
    [productId, payMethod],
  );

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'hidden' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'close' });
    dispatch({
      type: 'SET_GNB_RIGHT_CALLBACK',
      cb: () => {
        if (afterPaymentEndpoint) {
          const urls = (afterPaymentEndpoint as string).split('?');
          history.push(urls[0] ? urls[0] : '/', urls[1] && urls[1].length > 0 ? (parse(urls[1]) as Record<string, string>) : null, [
            'afterPaymentEndpoint',
          ]);
        } else {
          history.push('/');
        }
      },
    });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
      dispatch({ type: 'RESET_GNB_RIGHT_CALLBACK' });
    };
  }, []);

  return (
    <>
      <div className="container mt-6">
        <h1 className="N_20_R text-black">{t('payment/fail/title')}</h1>
        <div className="mt-10 N_14_R text-greyish-brown">{t('payment/fail/subtitle')}</div>
        <div className="mt-4 border border-ice-blue rounded p-6 N_14_R text-purpley-pink">{error_msg}</div>
        <div className="mt-6 grid grid-cols-2 gap-x-3">
          <Button
            theme="sub"
            title={t('payment/fail/home_button')}
            onClick={(e) => {
              e.preventDefault();
              history.push('/');
            }}
          ></Button>
          <Button title={t('payment/fail/retry_button')} onClick={onClickRetry}></Button>
        </div>
      </div>
      <ul className="container mt-10 py-6 N_12_R text-brown-grey bg-pale-grey list-disc">
        <li>{t('payment/fail/disclaimer_1')}</li>
        <li>{t('payment/fail/disclaimer_2')}</li>
        <li>{t('payment/fail/disclaimer_3')}</li>
      </ul>
    </>
  );
}
